// extracted by mini-css-extract-plugin
module.exports = {"root":"SheetGuests_root__wSmVo"};